/** Support inbox shown in the contact section, guarantee, and footer. */
export const SUPPORT_EMAIL = 'support@stockdigital.shop'
/**
 * TODO (pre-launch): both of these are placeholders. Swap in the real profile /
 * site URLs — until then they point at plausible destinations, not live pages.
 */
export const INSTAGRAM_URL = 'https://www.instagram.com/jazzteachersarsenal'
export const WEBSITE_URL = 'https://jazzteachersarsenal.com'
